const getActionsByRouteName = state => {
    return name => {
        return state.actions?.find(action => action.routeName === name)?.items ?? [];
    };
};

export default {
    getActionsByRouteName,
};
